module.exports = __webpack_public_path__ + "static/img/nodata.59bde155.png";